module.exports = __webpack_public_path__ + "img/高压储能电池.1d677330.png";